@if (isLoading) {
  <mat-progress-spinner
    diameter="24"
    color="primary"
    mode="indeterminate"
    data-cy="table-loader"
  ></mat-progress-spinner>
}
